// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  accessTokenUrl: 'https://us-central1-gulli-39333.cloudfunctions.net/getAccessToken',
  fcmUrl: 'https://fcm.googleapis.com//v1/projects/gulli-39333/messages:send',
  firebase: {
    apiKey: "AIzaSyAiYZUnNwoyZlOO1HgAXz02pHw5wqVKysw",
    authDomain: "gulli-39333.firebaseapp.com",
    projectId: "gulli-39333",
    storageBucket: "gulli-39333.appspot.com",
    messagingSenderId: "157785372572",
    appId: "1:157785372572:web:40dd06de121746b7fc7a59",
    measurementId: "G-3RGHT1C555",
    vapidKey: "BL7fflgqcGL3LOM2YtPevYR16NuJ0KyaT-U3e__GCw5scNVDkkKWD2lQSiXleG3qbkh-v_L8MmSsPVhZ8agbcks"
  },
  firebaseSecondary: {
    apiKey: "AIzaSyA5UYl3wBlE_oPuj1Q4mHXKjUi6l8K5qXw",
    authDomain: "gulli-orders---dev.firebaseapp.com",
    projectId: "gulli-orders---dev",
    storageBucket: "gulli-orders---dev.appspot.com",
    messagingSenderId: "927505398776",
    appId: "1:927505398776:web:479e0ff6b9a155c163740d",
    measurementId: "G-T779ZSYMPT"
  },
  googleMapsApiKey: 'AIzaSyCFFMS1aFooTIa-tZ1L5RXq6RDGvqae8Yk',
  analyticsApiUrl: 'https://analyticsdata.googleapis.com/v1beta/properties/369401135:runReport',
  s3Buckets: {
    development: 'gulli-development',
    developmentUae: 'gulli-development-uae',
    productionEu: 'gulli-production-eu',
    productionUae: 'gulli-production-uae'
  },

  // Cognito Identity Pool configuration
  cognito: {
    identityPoolId: 'us-east-1:d76ed665-1401-44fb-9d26-444bd10b6d0f', //
    region: 'eu-central-1', // Primary AWS region for S3 operations
    firebaseProjectId: 'gulli-39333', // Firebase project ID
    oidcProvider: 'securetoken.google.com/gulli-39333' // OIDC provider identifier
  },
  ordersBaseUrl: 'https://gulli-api.echo-dev.net/v1',
  paymentLinkUrl: 'https://lml-staging-cms-v2.iotics.ae/api/webhook/create-payment-link',
  funCityPlaygroundsIds: ['FunCity', 'fc_cm', 'fc_mm', 'fc_om'],
  serviceIds: {
    MALE_ID: 'Qwd3GkpPkwqi7EOuybc7',
    FEMALE_ID: 'SKAc8iZg4ugQgM048Atp'
  },
  staffId: 'YlbI8lH7pBSQzCaFseIbiEuNntd2'
};

// // test prod
// export const environment = {
//   production: false,
//   accessTokenUrl: 'https://us-central1-magnets-b9c8e.cloudfunctions.net/getAccessToken',
//   fcmUrl: 'https://fcm.googleapis.com//v1/projects/magnets-b9c8e/messages:send',
//   firebase: {
//     apiKey: "AIzaSyAFY9ljNyAtxxJTixLCYS2KdWn0BZp9wKU",
//     authDomain: "magnets-b9c8e.firebaseapp.com",
//     projectId: "magnets-b9c8e",
//     storageBucket: "magnets-b9c8e.appspot.com",
//     messagingSenderId: "1040941507160",
//     appId: "1:1040941507160:web:d1bec2f1792d328408a02d",
//     measurementId: "G-0K1M49VX8Z"
//   },
//   firebaseSecondary: {
//     apiKey: "AIzaSyBU4yoj8PDeYmF601iOn7EZkgmiGtUxxwc",
//     authDomain: "gulli-orders---prod.firebaseapp.com",
//     projectId: "gulli-orders---prod",
//     storageBucket: "gulli-orders---prod.appspot.com",
//     messagingSenderId: "918292539209",
//     appId: "1:918292539209:web:d8f0194a353c991f841c98",
//     measurementId: "G-18R0M3D6FJ"
//   },
//   googleMapsApiKey: 'AIzaSyCFFMS1aFooTIa-tZ1L5RXq6RDGvqae8Yk',  
//   analyticsApiUrl: 'https://analyticsdata.googleapis.com/v1beta/properties/331658960:runReport',
//   s3Buckets: {
//     development: 'gulli-development',
//     developmentUae: 'gulli-development-uae',
//     productionEu: 'gulli-production-eu',
//     productionUae: 'gulli-production-uae'
//   },
//   // Cognito Identity Pool configuration
//   cognito: {
//     identityPoolId: 'eu-central-1:8ee9193e-0d61-469d-bcc5-95389ca8bd93', // Replace with your production Identity Pool ID
//     // Note: Region is extracted from identityPoolId automatically
//     // The region field below is for S3 operations, not the Identity Pool region
//     region: 'eu-central-1', // Primary AWS region for S3 operations
//     firebaseProjectId: 'magnets-b9c8e', // Firebase project ID
//     oidcProvider: 'securetoken.google.com/magnets-b9c8e' // OIDC provider identifier
//   },
//   ordersBaseUrl: 'https://us-central1-gulli-orders---prod.cloudfunctions.net',
//   paymentLinkUrl: '',
//   funCityPlaygroundsIds: ['funCity', 'fcOasis', 'fbMotorCity', 'fcMercato', 'fcBawadi', 'fwYasMall', 'fcAlFalah', 'fcAbuDhabiMall', 'fcIBNBattuta'],
//   serviceIds: {
//     MALE_ID: 'iS3JBmVuYIwRAXVWO1gu',
//     FEMALE_ID: 'W7nbof9uFRpykARtx91T'
//   },
//   staffId: 'Gc2Mxu1GSSNKtaEndzvUI0uZysf1'
// };

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
